<script>
   /**************************************************************/
   /* Svelte component for ScoresPlot settings                   */
   /**************************************************************/

   import { Container, PlotTypeSelector } from '../controls';

   export let pvoptions = null;
   export let params;
   export let model;
   export let res;

   const plotTypeOptions = ['hm', 'bp'];
   let plotType = 'hm';

   $: params = {
      'plotType': plotType,
   }


</script>

{#if params && model && res && pvoptions}
<Container label="">
<p class="title">Scalars</p>
</Container>

<Container label="Plot type">
<PlotTypeSelector options={plotTypeOptions} bind:value={plotType} />
</Container>
{/if}
